import React, { Component } from "react";
import { connect } from "react-redux";
import history from "../Utils/History";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import {
  getPlanDetails,
  setStateParams,
  setFormData,
} from "../Redux/Actions/webAppActions";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import Rating from "@material-ui/lab/Rating";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import MoodOutlinedIcon from "@material-ui/icons/MoodOutlined";
import LocalPharmacyOutlinedIcon from "@material-ui/icons/LocalPharmacyOutlined";
import LocalHospitalOutlinedIcon from "@material-ui/icons/LocalHospitalOutlined";
import RemoveRedEyeOutlinedIcon from "@material-ui/icons/RemoveRedEyeOutlined";
import { Text } from "react-internationalization";
import { LANG } from "./translations/dynamic";
import { VERDA_CONSTS,ILS_CONSTS,fetchTeleSales } from "../Utils/StaticData/Constant";
const CustomCard = withStyles({})(Card);
const CustomCardHeader = withStyles({
  root: {
    display: "flex",
    alignItems: "center",
    height: "50px",
  },
  content: { display: "none" },
})(CardHeader);

class PlanCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comparePlans: this.props.comparePlans,
      snackBarOpen: false,
      snackBarMsg: "",
      vertical: "top",
      horizontal: "center",
      snackBarSeverty: "",
    };
  }

  copyLink = (e, productId) => {
    e.preventDefault();
    const dummy = document.createElement("p");
    const {
      deeplink,
      dpcountyName,
      dpzipCode,
      dpProductId,
      zipCode,
      CountyCd,
      stateCd,
      dpStateCd,
      countyName,
      dpemail,
      email,
      agentemail,
      year,
      lang,
    } = this.props;
    let zip = deeplink === true ? dpzipCode : zipCode;
    let county = CountyCd;
    let stateCD = deeplink === true ? dpStateCd : stateCd;
    let countyNm = deeplink === true ? dpcountyName : countyName.trim();
    let productID = deeplink === true ? dpProductId : productId?.trim();
    let emailAddr =
      deeplink === true ? dpemail : email?.length > 0 ? email : agentemail;
    dummy.textContent =
      window.location.href +
      "?" +
      "&" +
      "customerId=" +
      window.btoa(this.props?.customerId) +
      "&" +
      "zipCd=" +
      window.btoa(zip) +
      "&" +
      "countyCd=" +
      window.btoa(county) +
      "&" +
      "stateCd=" +
      window.btoa(stateCD) +
      "&" +
      "countyName=" +
      window.btoa(countyNm) +
      "&" +
      "productId=" +
      window.btoa(productID) +
      "&" +
      "email=" +
      window.btoa(emailAddr) +
      "&" +
      "planYear=" +
      window.btoa(year) +
      "&" +
      "userRole=" +
      window.btoa(
        this.props.beneficiaryLogin
          ? "beneficiary"
          : this.props.agentLogin
          ? "agent"
          : "guest"
      ) +
      "&" +
      "lang=" +
      window.btoa(lang) +
      "&" +
      "deepLink=true";

    document.body.appendChild(dummy);

    const range = document.createRange();
    range.setStartBefore(dummy);
    range.setEndAfter(dummy);

    const selection = window.getSelection();
    // // First clear, in case the user already selected some other text
    selection.removeAllRanges();
    selection.addRange(range);

    document.execCommand("copy");
    document.body.removeChild(dummy);
    this.setState({
      snackBarOpen: true,
      snackBarMsg:
        this.props.lang === "es"
          ? "¡Enlace copiado al portapapeles!"
          : "Link Copied to ClipBoard!",
      snackBarSeverty: "info",
    });
  };

  fetchPlanDetails = async (
    e,
    planId,
    planType,
    productId,
    premiumAmount,
    planName,
    productCategory
  ) => {
    e.preventDefault();
    window.sessionStorage.setItem(
      "cmpnames",
      JSON.stringify([
        {
          planId: planId,
          productId: productId,
          monthlyPremium: premiumAmount,
          planName: planName,
        },
      ])
    );
    let body = { customerId: this.props?.customerId };
    let formPayload = {
      planId: planId,
      productId: productId,
      premiumAmount: premiumAmount,
      planName: planName,
      productCategory: productCategory ? productCategory : "",
    };
    this.props.setFormData(formPayload);

    await this.props.setStateParams("detailsPlanType", planType.toLowerCase());
    await this.props.setStateParams("selectedPlansForCompare", [productId]);
    window.sessionStorage.setItem("selectedPlansForCompare",JSON.stringify([productId]))
    await this.props.getPlanDetails(body.customerId, productId,this.props.year);
    history.push("/e-Enroll/compare-plan");
  };

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      snackBarOpen: false,
    });
  };

  checkAlfabetAndSpecialChar = (value) => {
    var regExp = /[a-zA-Z]/g; //checking letters
    var format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/; // Checking special char
    if (regExp.test(value) || format.test(value)) {
      return value;
    } else {
      return "$" + value;
    }
  };

  render() {
    const { cardData, handleCheckedPlan, customerId, teleScript } = this.props;
    const { snackBarOpen, snackBarMsg, vertical, horizontal, snackBarSeverty } =
      this.state;
    const planName = cardData.planName;
    const planNameES = cardData.planNameES;

    let telescript = "";
    if (teleScript === true) {
      telescript = fetchTeleSales(customerId);
    }
    let type1 = "MA";
    let type2 = "MAPD";
    let type3 = "PDP";
    let type4 = "Medicare Supplement";
    let productType = cardData.productName?.trim();

    return (
      <div
        class={
          this.props?.customerId === "HCF0331"
            ? "card-plan height-28"
            : this.props?.sidebarexpanded === false
            ? "card-plan height-28"
            : this.props.agentLogin === true
            ? "card-plan height-31"
            : "card-plan height-30"
        }
      >
        <Snackbar
          open={snackBarOpen}
          autoHideDuration={3000}
          onClose={this.handleClose}
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
        >
          <Alert onClose={this.handleClose} severity={snackBarSeverty}>
            {snackBarMsg}
          </Alert>
        </Snackbar>
        <CustomCard class="MuiPaper-root MuiCard-root MuiPaper-elevation1 MuiPaper-rounded w-100">
          <CustomCardHeader
            className="card-header-plancard"
            action={
              <FormControlLabel
                control={
                  <input
                    type="checkbox"
                    checked={
                      this.props.comparePlans.indexOf(cardData.productId) !== -1
                    }
                    onChange={handleCheckedPlan}
                    value={cardData.productId}
                    className="plan-card-check m-2"
                    disabled={
                      this.props.disablePlan === true &&
                      this.props.comparePlans.indexOf(cardData.productId) === -1
                        ? true
                        : false
                    }
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                }
                label={
                  <Typography
                    variant="h6"
                    className="plancard-compare-plan-typography"
                  >
                    <Text id="plan.cbtcp" />
                  </Typography>
                }
              />
            }
          />
          <CardContent
            className={"muicard-body"}
            style={{ marginBottom: "2rem" }}
          >
            <h2 class="text-left plan-title">
              <span class="plancard-heading">
                {/* {this.props.lang === "es" && this.props.customerId === "HCF0331"
                  ? LANG.PLAN[cardData.productId]
                  : planName.toUpperCase()} */}
                {this.props.lang === "es" && planNameES
                  ? planNameES
                  : planName.toUpperCase()}
              </span>
            </h2>
            <span aria-label="Plan too new to be measured">
              <div class="rating text-left m-bottom-10">
                {cardData.rating > 0 && (
                  <Rating name="read-only" value={cardData.rating} readOnly />
                )}
                <p class="rating-description mb-0 plan-card-rating">
                  {cardData.ratingComment}
                </p>
              </div>
            </span>
            <section>
              <div className={"benifit-row"}>
                <div className={"premium-label"}>
                  <Text id="plan.monthlyp" />
                </div>
                <div className={"premium-value"}>
                  {cardData.monthlyPremium.includes("$")
                    ? cardData.monthlyPremium
                    : "$" + cardData.monthlyPremium}
                </div>
              </div>
            </section>
            <section className={"summary-view"}>
              <div className={"benifit-row card-padding"}>
                <div className={"description-label"}>
                  {/* {productType === type4 || productType === type3
                    ? */}
                  <Text id="app.plantype" />
                  {/* : "Type"} */}
                </div>
                <div className={"description-value"}>{cardData.planType}</div>
              </div>
              {this.props.productFilter != "PDP" &&
              (productType === type1 ||
                productType === type2 ||
                productType === type3 ||
                productType === type4) ? (
                <React.Fragment>
                  <div className={"benifit-row card-padding"}>
                    {cardData?.pcpCopay && cardData.pcpCopay != null && (
                      <>
                        <div className={"description-label"}>
                          <Text id="plan.PCPcopay" />
                        </div>
                        <div className={"description-value"}>
                          <Tooltip
                            className="mb-0"
                            aria-label={cardData.pcpCopay}
                            title={
                              <span>
                                {cardData.pcpCopay.indexOf("$") > -1
                                  ? cardData.pcpCopay
                                  : "$" + cardData.pcpCopay}{" "}
                                <Text id="plan.copay" />
                              </span>
                            }
                          >
                            <p>
                              {" "}
                              {cardData && cardData.pcpCopay
                                ? cardData.pcpCopay.indexOf(": ") > -1
                                  ? "$" + cardData.pcpCopay.split(": ")[1]
                                  : cardData.pcpCopay.indexOf("$") > -1
                                  ? cardData.pcpCopay
                                  : this.checkAlfabetAndSpecialChar(
                                      cardData.pcpCopay
                                    )
                                : this.checkAlfabetAndSpecialChar(
                                    cardData.pcpCopay
                                  )}
                            </p>
                          </Tooltip>
                        </div>
                      </>
                    )}
                  </div>

                  <div className={"benifit-row card-padding"}>
                    {cardData?.specialistCopay &&
                      cardData.specialistCopay != null && (
                        <>
                          <div className={"description-label"}>
                            <Text id="plan.scopay" />
                          </div>
                          <div className={"description-value"}>
                            <Tooltip
                              className="mb-0"
                              aria-label={cardData.specialistCopay}
                              title={
                                <span>
                                  {cardData.specialistCopay.indexOf("$") > -1
                                    ? cardData.specialistCopay
                                    : "$" + cardData.specialistCopay}{" "}
                                  <Text id="plan.copay" />
                                </span>
                              }
                            >
                              <p>
                                {" "}
                                {cardData.specialistCopay.indexOf("$") > -1
                                  ? cardData.specialistCopay
                                  : "$" + cardData.specialistCopay}
                              </p>
                            </Tooltip>
                          </div>
                        </>
                      )}
                  </div>
                </React.Fragment>
              ) : null}
              {this.props.productFilter != "MA" &&
              (productType === type2 ||
                productType === type3 ||
                productType === type1 ||
                productType === type4) ? (
                <React.Fragment>
                  <div className={"benifit-row card-padding"}>
                    {cardData?.preferredGeneric &&
                      cardData.preferredGeneric != null && (
                        <>
                          <div className={"description-label"}>
                            <Text id="plan.preferredg" />
                          </div>
                          <div className={"description-value"}>
                            <Tooltip
                              className="plan-detail-content2 mb-0 "
                              title={
                                <span>
                                  {cardData.preferredGeneric.indexOf("$") > -1
                                    ? cardData.preferredGeneric
                                    : "$" + cardData.preferredGeneric}{" "}
                                  <Text id="plan.copay" />
                                </span>
                              }
                            >
                              <p>
                                {cardData.preferredGeneric.indexOf("$") > -1
                                  ? cardData.preferredGeneric
                                  : "$" + cardData.preferredGeneric}
                              </p>
                            </Tooltip>
                          </div>
                        </>
                      )}
                  </div>
                  <div className={"benifit-row card-padding"}>
                    {cardData?.preferredBrand &&
                      cardData.preferredBrand != null && (
                        <>
                          <div className={"description-label"}>
                            <Text id="plan.preferredb" />
                          </div>
                          <div className={"description-value"}>
                            <Tooltip
                              className="plan-detail-content2 mb-0 "
                              title={
                                <span>
                                  {cardData.preferredBrand.indexOf("$") > -1
                                    ? cardData.preferredBrand
                                    : "$" + cardData.preferredBrand}{" "}
                                  <Text id="plan.copay" />
                                </span>
                              }
                            >
                              <p>
                                {cardData.preferredBrand.indexOf("$") > -1
                                  ? cardData.preferredBrand
                                  : "$" + cardData.preferredBrand}
                              </p>
                            </Tooltip>
                          </div>
                        </>
                      )}
                  </div>
                </React.Fragment>
              ) : null}
              {productType === type4 ||
              productType === type3 ||
              productType === type2 ||
              productType === type1 ? (
                <React.Fragment>
                  {cardData?.partADeductible &&
                    cardData.partADeductible != null && (
                      <div className={"benifit-row card-padding"}>
                        {cardData?.partADeductible &&
                          cardData.partADeductible != null && (
                            <>
                              <div className={"description-label"}>
                                <Text id="plan.partAd" />
                              </div>
                              <div className={"description-value"}>
                                <Tooltip
                                  className="plan-detail-content2 mb-0 "
                                  title={
                                    <span>
                                      {cardData.partADeductible.indexOf("$") >
                                      -1
                                        ? cardData.partADeductible
                                        : "$" + cardData.partADeductible}{" "}
                                      <Text id="plan.copay" />
                                    </span>
                                  }
                                >
                                  <p>
                                    {cardData.partADeductible.indexOf("$") > -1
                                      ? cardData.partADeductible
                                      : "$" + cardData.partADeductible}
                                  </p>
                                </Tooltip>
                              </div>
                            </>
                          )}
                      </div>
                    )}
                  {cardData?.partBDeductible &&
                    cardData.partBDeductible != null && (
                      <div className={"benifit-row card-padding"}>
                        {cardData?.partBDeductible &&
                          cardData.partBDeductible != null && (
                            <>
                              <div className={"description-label"}>
                                <Text id="plan.partBd" />
                              </div>
                              <div className={"description-value"}>
                                <Tooltip
                                  className="plan-detail-content2 mb-0 "
                                  title={
                                    <span>
                                      {cardData.partBDeductible.indexOf("$") >
                                      -1
                                        ? cardData.partBDeductible
                                        : "$" + cardData.partBDeductible}{" "}
                                      <Text id="plan.copay" />
                                    </span>
                                  }
                                >
                                  <p>
                                    {cardData.partBDeductible.indexOf("$") > -1
                                      ? cardData.partBDeductible
                                      : "$" + cardData.partBDeductible}
                                  </p>
                                </Tooltip>
                              </div>
                            </>
                          )}
                      </div>
                    )}
                </React.Fragment>
              ) : null}
              {productType === type3 ||
              productType === type4 ||
              productType === type2 ||
              productType === type1 ? (
                <div className={"benifit-row card-padding"}>
                  {cardData?.partDDeductible &&
                    cardData.partDDeductible != null && (
                      <>
                        <div className={"description-label p-right-0"}>
                          <Text id="plan.partDd" />
                        </div>
                        <div className={"description-value1"}>
                          <Tooltip
                            className="plan-detail-content2 mb-0 "
                            title={
                              <span>
                                {cardData.partDDeductible.indexOf("$") > -1
                                  ? cardData.partDDeductible
                                  : "$" + cardData.partDDeductible}{" "}
                                <Text id="plan.copay" />
                              </span>
                            }
                          >
                            <p className="plan-detail-content3">
                              {cardData.partDDeductible.indexOf("$") > -1
                                ? cardData.partDDeductible
                                : "$" + cardData.partDDeductible}
                            </p>
                          </Tooltip>
                        </div>
                      </>
                    )}
                </div>
              ) : null}
            </section>
            {/* </div> */}
            <section class="p-left-0rem">
              <div>
                {productType === type3 ? (
                  <div class="col-md-2 p-right-0rem p-left-0rem">
                    <span class="p-right-0-5rem p-left-0rem">
                      <Tooltip
                        title="Coverage includes prescription drugs"
                        aria-label="Coverage includes prescription drugs"
                      >
                        <LocalPharmacyOutlinedIcon className="icons-style plancard-icon-font" />
                      </Tooltip>
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {productType === type1 ? (
                  <div class="col-md-4 p-left-0rem p-right-0rem">
                    <span class="p-left-0rem">
                      <Tooltip
                        title="Coverage for health care providers,outpatient services,labs and screening are included."
                        aria-label="Coverage for health care providers,outpatient services,labs and screening are included."
                      >
                        <LocalHospitalOutlinedIcon className="icons-style plancard-icon-font" />
                      </Tooltip>
                    </span>
                    <span class="p-right-0-5rem p-left-0-4rem">
                      <Tooltip
                        title="Coverage includes routine dental exams"
                        aria-label="Coverage includes routine dental exams"
                      >
                        <MoodOutlinedIcon className="icons-style plancard-icon-font" />
                      </Tooltip>
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {(productType === type2 && cardData.preferredGeneric) ==
                "44.00" ? (
                  <div class="col-md-8 p-right-0rem p-left-0rem">
                    <span class="p-left-0rem p-top-2rem">
                      <Tooltip
                        title="Coverage includes prescription drugs"
                        aria-label="Coverage includes prescription drugs"
                      >
                        <LocalPharmacyOutlinedIcon className="icons-style plancard-icon-font" />
                      </Tooltip>
                    </span>
                    <span class="p-top-2rem p-left-0-5rem p-right-0-5rem">
                      <Tooltip
                        title="Coverage for health care providers,outpatient services,labs and screening are included."
                        aria-label="Coverage for health care providers,outpatient services,labs and screening are included."
                      >
                        <LocalHospitalOutlinedIcon className="icons-style plancard-icon-font" />
                      </Tooltip>
                    </span>
                    <span class="p-right-0-5rem p-top-2rem p-left-0rem">
                      <Tooltip
                        title="Coverage includes routine dental exams"
                        aria-label="Coverage includes routine dental exams"
                      >
                        <MoodOutlinedIcon className="icons-style plancard-icon-font" />
                      </Tooltip>
                    </span>
                    <span class="p-left-0rem p-top-2rem">
                      <Tooltip
                        title="Coverage includes new standard eye glasses and frames annually."
                        aria-label="Coverage includes new standard eye glasess and frames annually."
                      >
                        <RemoveRedEyeOutlinedIcon className="icons-style plancard-icon-font" />
                      </Tooltip>
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {(productType === type2 && cardData.preferredGeneric) ==
                "23.00" ? (
                  <div class="col-md-4 p-left-0rem p-right-0rem">
                    <span class="plan-detail-last p-top-2rem p-left-0rem">
                      <Tooltip
                        title="Coverage includes prescription drugs"
                        aria-label="Coverage includes prescription drugs"
                      >
                        <LocalPharmacyOutlinedIcon className="icons-style plancard-icon-font" />
                      </Tooltip>
                    </span>
                    <span class="p-right-0-5rem p-top-2rem p-left-0-4rem">
                      <Tooltip
                        title="Coverage for health care providers,outpatient services,labs and screening are included."
                        aria-label="Coverage for health care providers,outpatient services,labs and screening are included."
                      >
                        <LocalHospitalOutlinedIcon className="icons-style plancard-icon-font" />
                      </Tooltip>
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {(productType === type2 && cardData.preferredGeneric) ==
                "$12" ? (
                  <div class="col-md-4 p-right-0rem p-left-0rem">
                    <span class="plan-detail-last p-left-0rem p-top-2rem">
                      <Tooltip
                        title="Coverage includes prescription drugs"
                        aria-label="Coverage includes prescription drugs"
                      >
                        <LocalPharmacyOutlinedIcon className="icons-style plancard-icon-font" />
                      </Tooltip>
                    </span>
                    <span class="p-top-2rem p-right-0-5rem p-left-0-4rem">
                      <Tooltip
                        title="Coverage for health care providers,outpatient services,labs and screening are included."
                        aria-label="Coverage for health care providers,outpatient services,labs and screening are included."
                      >
                        <LocalHospitalOutlinedIcon className="icons-style plancard-icon-font" />
                      </Tooltip>
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </section>
            {this.props?.customerId != "HCF0331" &&
              (productType === type3 ||
                productType === type1 ||
                (productType === type2 && cardData.preferredGeneric) ==
                  "44.00" ||
                (productType === type2 && cardData.preferredGeneric) ==
                  "23.00" ||
                (productType === type2 && cardData.preferredGeneric) ==
                  "$12") && (
                <section class="row col-12">
                  <p className="icon1-info">
                    <Text id="plan.hoveraboveicon" />
                  </p>
                </section>
              )}
          </CardContent>
          <div className="link_container">
            <div className="main_box">
              <div className="box">
                <button
                  className="link_buttons border-right plan-card-details-mobile-font-size"
                  onClick={(e) =>
                    this.fetchPlanDetails(
                      e,
                      cardData.planId,
                      cardData.productName,
                      cardData.productId,
                      cardData.monthlyPremium,
                      // cardData.planName,
                      this.props.lang === "es" && cardData.planNameES
                        ? cardData.planNameES
                        : cardData.planName.toUpperCase(),
                      cardData?.productCategory
                    )
                  }
                >
                  <Text id="plan.details" />
                </button>
                <button
                  className="link_buttons border-right plan-card-details-mobile-font-size"
                  onClick={this.props.openModal(cardData.productId)}
                >
                  <Text id="user.Email" />
                </button>
                <button
                  className="link_buttons border-right plan-card-details-mobile-font-size"
                  onClick={(e) => this.copyLink(e, cardData.productId)}
                >
                  <Text id="plan.copy" />
                </button>
                {this.props.agentLogin === true &&
                  [VERDA_CONSTS.ID,ILS_CONSTS.ID].every((ids)=>ids!==customerId) && (
                    <>
                      <button
                        className="link_buttons border-right plan-card-details-mobile-font-size"
                        onClick={(e) => {
                          e.preventDefault();
                          window.open(
                            telescript,
                            "_blank",
                            "scrollbars=yes,resizable=yes,width=600,height=600"
                          );
                        }}
                      >
                        <Text id="plan.telesales" />
                      </button>
                    </>
                  )}
              </div>
              <div className="box p-right-0-4em">
                <Button
                  id="btn_select"
                  variant="contained"
                  value={planName}
                  onClick={(e) =>
                    this.props.handleSelect(
                      e,
                      cardData.planId,
                      //cardData.planName,
                      this.props.lang === "es" && cardData.planNameES
                        ? cardData.planNameES
                        : cardData.planName.toUpperCase(),
                      cardData.productName,
                      cardData.productId,
                      cardData.monthlyPremium,
                      cardData?.productCategory,
                      cardData?.pbpId
                    )
                  }
                >
                  <Text id="header.enroll" />
                </Button>
              </div>
            </div>
          </div>
        </CustomCard>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    year: state.webApp.year?.planYear
      ? state.webApp.year.planYear
      : state.webApp.year,
    email: state.login.emailAddress,
    guestLoggedIn: state.login.guestLogin,
    zipCode: state.webApp.zip,
    agentLogin: state.login.agentLoggedIn,
    beneficiaryLogin: state.login.beneficiaryLogin,
    countyName: state.webApp.county?.countyName
      ? state.webApp.county?.countyName
      : state.webApp.county,
    stateCd: state.webApp.stateCd,
    CountyCd: state.webApp.CountyCd,
    agentemail: state.login.agentEmailId,
    customerId: state.login.customerId,
    lang: state.webApp.language,
    deeplink: state.login.deeplink,
    dpcountyName: state.login.dpcountyName,
    dpzipCode: state.login.dpzipCode,
    dpProductId: state.login.dpProductId,
    dpStateCd: state.login.dpStateCd,
    dpemail: state.login.dpemail,
    theme: state.login.theme,
  };
};
const mapDispatchToProps = {
  getPlanDetails,
  setStateParams,
  setFormData,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanCard);
